<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Brand Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:" label-for="name">
                                    <b-form-input id="name" placeholder="Enter brand name" :state="validateField(name)"
                                        v-model="name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Category Name:" label-for="category_id">
                                <b-form-select id="category_id" v-model="category_id" :options="categories" required>
                                </b-form-select>
                            </b-form-group>
                            </div> -->
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Category Name:" label-for="category_id">
                                <MultiSelect id="category_id" v-model="category_id" :options="categories" optionLabel="text" optionValue="value" dataKey="value"
                                    filter placeholder="Select Category" :maxSelectedLabels="1" class="fixed-width"/>      
                            </b-form-group>
                            </div>
                            
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Images:" label-for="image">
                                    <div style="margin-left: 3px; margin-bottom: 15px">
                                        <input type="file" accept="image/*" id="image" @change="onProfilePictureChange" />
                                    </div>
                                </b-form-group>
                            </div> -->
                            <!-- Brand Image -->
                            <b-col cols="12" md="6">
                                <b-form-group
                                label="Brand Image:"
                                description="Recommended size: 300x300px (JPG/PNG)"
                                label-class="font-weight-bold"
                                >
                                <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onDrop"
                                    @dragover.prevent
                                    @click="$refs.fileInput.click()"
                                >
                                    <div v-if="!imagePreview">
                                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else>
                                    <img
                                        :src="imagePreview"
                                        alt="Preview"
                                        class="img-thumbnail"
                                        style="max-height: 120px;"
                                    />
                                    </div>
                                    <input
                                    ref="fileInput"
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    class="d-none"
                                    @change="onFileChange"
                                    />
                                </div>
                                <small class="text-muted">
                                    Only JPG/PNG, Max size: 2MB
                                </small>
                                <b-form-invalid-feedback v-if="imageError">
                                    {{ imageError }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </div>

                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>
                
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";
import MultiSelect from "primevue/multiselect";
import imageCompression from 'browser-image-compression';

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            showModal: false,
            isLoading: false,
            category_id: [], // The selected category ID
            categories: [], 
            name: "",
            image: '', // New data property for multiple images
            successMessage: "", // Add this line for the success message
            errorMessage: "",
            imagePreview: null,
            imageError: "",


        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast, 
        BSpinner,
        MultiSelect,
    },
                mounted() {
                axios.get('CategoryList')
                    .then(response => {
                        // Check if the response is successful and contains data
                        if (response.data.success && response.data.data) {
                            // Map the API response to the format required by b-form-select
                            this.categories = response.data.data.map(category => ({
                                value: category.id,  
                                text: category.title 
                            }));
                        } else {
                            console.error('Unexpected response format:', response.data);
                        }
                    })
                    .catch(error => {
                    });
            },
    methods: {
          validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },
      
      

        addUser() {
            this.isLoading = true;
            this.imageError = "";
            const formData = new FormData();
            formData.append("image", this.image);
            formData.append("name", this.name);
            // formData.append("category_id", this.category_id);
            formData.append("category_id", this.category_id[0] || "");
          
            axios

                .post("brandStore", formData)
                .then((response) => {
                
                    this.$bvToast.toast("Brand added successfully!", {
                        title: "Success",
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                        variant: "primary", 
                    });
                    this.isLoading = false;
                    this.$router.push({ name: 'ListBrand' });
                })
                // .catch((error) => {
                //     this.errors = error.response.data.errors;
                //     this.isLoading = false;
                // });
                .catch((error) => {
                this.isLoading = false;
                const message =
                    error.response?.data?.message ||
                    "An error occurred while adding the brand.";

                // Use toast or set a visible error message
                this.$bvToast.toast(message, {
                    title: "Message",
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-right",
                    autoHideDelay: 5000,
                });

                // Optional: Store for use in <template> if not using toast
                this.errorMessage = message;
            });

        },
          
        async onProfilePictureChange(event) {
            const file = event.target.files[0];
            if (file) {
                try {
                    const options = {
                        maxSizeMB: 1,
                        maxWidthOrHeight: 1024,
                        useWebWorker: true
                    };
                    
                    const compressedFile = await imageCompression(file, options);
                    this.image = compressedFile;
                } catch (error) {
                    console.error("Image compression error:", error);
                    this.image = file;
                }
            }
        },
        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
        async onFileChange(event) {
      const file = event.target.files[0];
      await this.handleFile(file);
    },
    async onDrop(e) {
      const file = e.dataTransfer.files[0];
      await this.handleFile(file);
    },
    async handleFile(file) {
      if (!file) return;
      if (!["image/jpeg", "image/png"].includes(file.type)) {
        this.imageError = "Only JPG/PNG allowed.";
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.imageError = "Max size is 2MB.";
        return;
      }

      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 600,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(file, options);
        this.image = compressedFile;
        this.imagePreview = URL.createObjectURL(compressedFile);
        this.imageError = "";
      } catch (err) {
        this.image = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },
    },
};
</script>
<style>
.fixed-width {
  width: 100%;
  border-radius: 6px;
}
.b-form-group > label {
  font-weight: bold !important;
}
</style>